"use client";

import { isOptedOutCCPA } from "@utilities/ccpa";
import { isGPCEnabled } from "@utilities/gpc";
import { logger } from "@utilities/logger";
import { useMarketingConsent } from "@utilities/useConsent";
import dynamic from "next/dynamic";

// Dynamically import the analytics component to avoid blocking initial page load
const AnalyticsComponent = dynamic(() => import("./AnalyticsComponent"), {
  ssr: false, // Disable SSR since this is client-side analytics
  loading: () => null, // No loading state needed for analytics
});

// Error boundary component for analytics
function AnalyticsErrorBoundary({ children }: { children: React.ReactNode }) {
  try {
    return <>{children}</>;
  } catch (error) {
    // Silently fail analytics to not break the user experience
    logger.warn("Analytics failed to load:", error);
    return null;
  }
}

export default function Analytics() {
  const { hasConsent } = useMarketingConsent();

  if (!hasConsent || isOptedOutCCPA() || isGPCEnabled()) {
    return null;
  }

  return (
    <AnalyticsErrorBoundary>
      <AnalyticsComponent />
    </AnalyticsErrorBoundary>
  );
}
